import { createContext } from 'react';
export const FileURLContext = createContext();